import {
    getIdentificationTypes,
    initMercadoPago,
    createCardToken,
    CardNumber,
    SecurityCode,
    ExpirationDate,
} from '@mercadopago/sdk-react';
import { useEffect, useState } from 'react';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import ButtonLoading from '../../atoms/buttonLoading/view';
import './cardtoken.css';

const MP_PUBLIC_KEY = process.env.REACT_APP_MP_PUBLIC_KEY || 'APP_USR-1a6d2780-ce64-4c60-82a3-29d1bdeb6eb0';

if (MP_PUBLIC_KEY) {
    initMercadoPago(MP_PUBLIC_KEY);
}

const MP_STYLE = {
    placeholderColor: "rgba(255,255,255,0.3)",
    fontSize: "15px",
    color: "#ffffff",
};

const CardToken = ({ onsubmit }) => {
    const [idTypes, SetIdTypes] = useState([]);

    useEffect(() => {
        getIdentificationTypes().then((res) => SetIdTypes(res || []));
    }, []);

    const getToken = async () => {
        const cardID = window.document.getElementById("card-id").value;
        if (isNaN(cardID) || cardID.trim() === "") {
            dispatchCustomEvent("loading-btn-token", null);
            dispatchCustomEvent("popup", { message: "El ID debe ser un número válido.", type: "error" });
            return;
        }
        createCardToken({
            cardholderName: window.document.getElementById("card-name").value,
            identificationType: window.document.getElementById("card-id-type").value,
            identificationNumber: cardID,
        }).then((cardToken) => {
            onsubmit(cardToken);
        }).catch(() => {
            dispatchCustomEvent("loading-btn-token", null);
            dispatchCustomEvent("popup", { message: "Error al procesar la tarjeta. Verifica los datos.", type: "error" });
        });
    };

    return (
        <div className="ct-wrapper">
            <h3 className="ct-title">Detalles de pago</h3>
            <p className="ct-section-label">Datos de la tarjeta</p>

            {/* Card Number */}
            <div className="ct-field">
                <label className="ct-label">Número de tarjeta</label>
                <div className="ct-mp-field">
                    <CardNumber
                        placeholder="1234 5678 9012 3456"
                        style={MP_STYLE}
                    />
                </div>
            </div>

            {/* Security + Expiry */}
            <div className="ct-row">
                <div className="ct-field ct-half">
                    <label className="ct-label">Código de seguridad</label>
                    <div className="ct-mp-field">
                        <SecurityCode placeholder="CVV" style={MP_STYLE} />
                    </div>
                </div>
                <div className="ct-field ct-half">
                    <label className="ct-label">Fecha de vencimiento</label>
                    <div className="ct-mp-field">
                        <ExpirationDate placeholder="MM/AA" mode="short" style={MP_STYLE} />
                    </div>
                </div>
            </div>

            <div className="ct-divider" />
            <p className="ct-section-label">Datos del titular</p>

            {/* Name */}
            <div className="ct-field">
                <label className="ct-label">Nombre completo</label>
                <input
                    id="card-name"
                    className="ct-input"
                    placeholder="Como aparece en la tarjeta"
                    autoComplete="cc-name"
                />
            </div>

            {/* ID Type + Number */}
            <div className="ct-row">
                <div className="ct-field" style={{ flex: '0 0 140px' }}>
                    <label className="ct-label">Tipo doc.</label>
                    <select id="card-id-type" className="ct-input ct-select">
                        {idTypes?.map(item => (
                            <option key={item.id} value={item.id}>{item.name}</option>
                        ))}
                    </select>
                </div>
                <div className="ct-field" style={{ flex: 1 }}>
                    <label className="ct-label">Número de documento</label>
                    <input
                        id="card-id"
                        className="ct-input"
                        placeholder="12345678"
                        autoComplete="off"
                    />
                </div>
            </div>

            <ButtonLoading
                id="token"
                onClick={getToken}
                title="Finalizar compra"
                style={{ marginTop: '8px' }}
            />
        </div>
    );
};

export default CardToken;
